module.exports = __webpack_public_path__ + "img/5.af5c3cb5.png";